import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Link,
} from "../../../../../../../components/DesignSystem/Button/Button";

const propTypes = {
  t: PropTypes.func.isRequired,
  url: PropTypes.func.isRequired,
  anchored: PropTypes.bool,
  lang: PropTypes.string.isRequired,
};

const TakeAction = ({ t, anchored, url }) => {
  const openFreshdeskHelpWidget = () => {
    // eslint-disable-next-line new-cap
    window.FreshworksWidget("open");
  };

  return (
    <section className="LandingPage-section LandingPage-takeAction">
      <h2 className="LandingPage-takeAction-heading">
        {t("spages.referrals.landing.sections.TakeAction.title")}
      </h2>
      <div className="LandingPage-takeAction-sectionContainer">
        <div className="LandingPage-takeAction-callToAction">
          <p className="LandingPage-takeAction-text">
            {t("spages.referrals.landing.sections.TakeAction.description")}
          </p>
          <div
            className={`LandingPage-takeAction-button-outer${
              anchored ? " anchored" : ""
            }`}
          >
            <Link
              className="LandingPage-takeAction-createListingButton"
              href={url("createListing")}
              colorVariant="primary"
              size="medium"
            >
              {t("spages.referrals.landing.sections.TakeAction.action")}
            </Link>
            <Button
              colorVariant="secondary"
              onClick={openFreshdeskHelpWidget}
              size="medium"
              className="LandingPage-takeAction-contactBtn"
            >
              {t("spages.referrals.landing.sections.Hero.contactUs")}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

TakeAction.propTypes = propTypes;
export default TakeAction;
